import { EntityKeyConfig } from '../../../types/entities';

/**
 * Entity Keys for UnitSystems
 *
 * Defines the key structure used throughout the application
 * for this entity type.
 */
export const keys: EntityKeyConfig = {
  single: 'unitSystem',
  plural: 'unitSystems',
  state: 'unitSystems'
};